// export const enAPI = 'http://localhost:5000/api/idm/registration/';
export const enAPI = `https://laj12imsee.execute-api.us-east-1.amazonaws.com/api/idm/registration/`;

export const SITE_KEY_V2 = '6LeiE1waAAAAAA3eXNIkqXqckrKNX4lsS37_o_Zp';
export const SITE_KEY_V3 = `6LfGE1waAAAAAOh_rz-gsFH_y52242iXHzk5PyJz`;
export const DS_APP_URL = `https://dealersource.sel.sony.com/ds/s/home.htm`;
export const DS_APP_LOGO_URL = 'https://dealersource.sel.sony.com';
